module.exports = {"StatusCode":200,"Payload":"[{\"zone\":{\"Id\": \"some/long-id-here\"}}]"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/checkPurchasedStatus.json
// module id = vxax
// module chunks = 0